// Module
var code = "<ticket-status ng-if=\"vm.ticketStatus === 'declined'\" status=declined translate=app.ticket.messages.declined> </ticket-status> <form class=ticket-detail-container name=vm.ticketForm role=form novalidate focus-invalid> <div ui-view autoscroll class=form-content></div> </form> ";
// Exports
var _module_exports = code;;
var path = 'app/components/ticket/partials/ticket.detail.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;